<template>
  <div>
    <div class="">
      <div class="task-info" v-if="work">
        <div class="task-info__wrapper">
          <div class="flex ai-center task-info__content">
            <div class="task-item__img-content" :style="`color: ${work.lessonplan.discipline.color};`" :title="work.lessonplan.discipline.title">
              <img :src="work.lessonplan.discipline.icon" alt="">
            </div>
            <div class="task-info__desc">
              <div class="text-x3 fw-6 md-min:m-b-1">{{ work['title'] }}</div>
              <div class="md-min:m-b-1">
                {{work.lessonplan.discipline.title}}
              </div>
              <div>{{ $store.state.text.lesson_theme }} {{ work.lessonplan.title }}</div>
            </div>
          </div>
          <div class="task-info__date">
            <div class="flex ai-center" v-if="work['created_at']">
              Дата создания:
              <span class="m-l-2">
                {{ new Date(work['created_at']).toLocaleString() }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <QuestionCard :data="item" v-if="item" class="m-t-6"/>
    </div>
  </div>
</template>

<script>
import { cardContent } from "@/plugins/functions";
import QuestionCard from "@/components/Question/QuestionCard";
import 'vuetify/dist/vuetify.min.css'
export default {
  data() {
    return {
      item: null,
      work: null,
      cardLink: "business/works",
    };
  },
  computed:{
  },
  components: {
    QuestionCard
  },
  props: ['id'],
  methods: {
    cardContent: cardContent,
  },
  async created(){
    this.item = await this.cardContent(this.cardLink, this.id);
    this.work = this.item;
  },

};
</script>

